document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  const section = document.querySelector(".agilitas-lab-scroll-hero");
  if (!section) return;
  const words = gsap.utils.toArray(
    ".agilitas-lab-title .word"
  );
  const media = section.querySelector(
    ".agilitas-lab-media-wrapper"
  );
  const intro = section.querySelector(
    ".agilitas-lab-intro"
  );
  const story = section.querySelector(
    ".agilitas-lab-story"
  );

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "bottom bottom",
      scrub: true
    }
  });

  words.forEach((word) => {
    tl.to(
      word,
      {
        color: "#111",
        duration: 0.25
      }
    );
  });

  tl.to(
    intro,
    {
      y: -300,
      opacity: 0,
      duration: 1
    },
    "+=0.2"
  );

  if(window.innerWidth > 768){
    tl.to(
      media,
      {
        width:"100vw",
        height:"100vh",
        top:"50%",
        left:"50%",
        x:0,
        y:0,
        borderRadius:0,
        duration:1.5,
        onStart:()=>{
          media.classList.add("zoomed");
        }
      },
      "<"
    );
  }
  else{
    tl.to(
      media,
      {
        width:"100vw",
        height:"100vh",
        top:"50%",
        left:"50%",
        x:0,
        y:0,
        borderRadius:0,
        duration:1.5,
        onStart:()=>{
          media.classList.add("zoomed");
        }
      },
      "<"
    );
  }

  tl.to(
    story,
    {
      opacity:1,
      y:0,
      duration:1
    },
    "-=0.4"
  );
});